import { render, staticRenderFns } from "./DomainAuthenticateForm.vue?vue&type=template&id=fb44d842&scoped=true"
import script from "./DomainAuthenticateForm.vue?vue&type=script&lang=js"
export * from "./DomainAuthenticateForm.vue?vue&type=script&lang=js"
import style0 from "./DomainAuthenticateForm.vue?vue&type=style&index=0&id=fb44d842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb44d842",
  null
  
)

export default component.exports